import { css } from '@emotion/react'
import { medium, small } from '../../GlobalStyles'

export const NextPreviousStyle = css`



    margin: 0px;
    padding: 0px;
    width: auto;
    display: flex;
    justify-content: space-between;

  
    a:focus {
        text-decoration: none;
    }
  
    

    
    .smallContent {
        display: block;
        margin: 0px;
        padding: 0px;
        color: rgb(157, 170, 182);
    }
    
    .smallContent span {
        font-size: 12px;
        line-height: 1.625;
        font-weight: 400;
    }
    
    .nextPreviousTitle {
        display: block;
        margin: 0px;
        padding: 0px;
        transition: color 200ms ease 0s;
    }
    
    .nextPreviousTitle span {
        font-size: 16px;
        line-height: 1.5;
        font-weight: 500;
        ${medium}{
            font-size: 11px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    
    .nextBtn{
        margin-left: auto;
    }

    .nextBtn,
    .previousBtn {
        width: 49%;
        cursor: pointer;
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        place-self: stretch;
        align-self: flex-end;
        color: rgb(36, 42, 49);
        background-color: rgb(255, 255, 255);
        border-radius: 3px;
        border: 1px solid rgb(230, 236, 241);
        transition: border 200ms ease 0s;
        box-shadow: rgba(116, 129, 141, 0.1) 0px 3px 8px 0px;
        text-decoration: none;
    }
    
    .arrow{
        font-size: 24px;
        transition: color 200ms ease 0s;
        display: block;
        margin: 0px;
        color: rgb(157, 170, 182);
        align-self: center;
        padding-top: 5px;

        &.rightArrow{
            padding-right: 5px;
        }
        &.leftArrow{
            padding-left: 5px;
        }

        ${medium}{
            align-self: start;;
        }
    }

    
    .nextRightWrapper {
        display: block;
        padding: 16px;
        min-width: 0;
        flex-grow: 1;
    }
    .preRightWrapper {
        display: block;
        padding: 16px;
        text-align: right;
        min-width: 0;
        flex-grow: 1;
    }
    
    .nextBtn:hover, .previousBtn:hover {
        text-decoration: none;
        border: 1px solid var(--primary-color);
        box-shadow: rgba(116, 129, 141, 0.1) 0px 3px 4px 0px, box-shadow, rgba(255, 224, 0, 0.8) 0px 8px 8px 4px;;
    }
    
    .nextBtn:hover .rightArrow, .previousBtn:hover .leftArrow {
        color: var(--primary-color);
    }
`